module.exports = __webpack_public_path__ + "img/bus-warbe-diag.43bbb7f0.png";